import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from './CurrentUserContext';
import { can } from './permissions';

export default function RequirePermission({ action, children }) {
  const { user } = useCurrentUser();
  if (!can(user, action)) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}

RequirePermission.propTypes = {
  action: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
